export const messages = {
  en: {
    shopHouse: {
      queryCondition: 'Query Conditions',
      shopHouseInfo: 'Warehouse Information',
      shId: 'Warehouse ID',
      shName: 'Warehouse Name',
      shType: 'Warehouse Type',
      shDesc: 'Description',
      createTime: 'Create Time',
      inputShId: 'Please input warehouse ID',
      inputShName: 'Please input warehouse name',
      selectShType: 'Please select warehouse type',
      inputShDesc: 'Please input description',
      normalWarehouse: 'Normal Warehouse',
      mainWarehouse: 'Main Warehouse',
      addShopHouse: 'Add Warehouse',
      editShopHouse: 'Edit Warehouse',
      deleteConfirm: 'Delete Confirmation',
      deleteShopHouseConfirm: 'Are you sure to delete this warehouse?',
      shNameRequired: 'Warehouse name is required',
      shTypeRequired: 'Warehouse type is required',
      shDescRequired: 'Description is required',
      shIdRequired: 'Warehouse ID is required',
      shNameTooLong: 'Warehouse name is too long',
      shDescTooLong: 'Description is too long'
    }
  },
  zh: {
    shopHouse: {
      queryCondition: '查询条件',
      shopHouseInfo: '仓库信息',
      shId: '仓库编号',
      shName: '仓库名称',
      shType: '仓库类型',
      shDesc: '描述',
      createTime: '创建时间',
      inputShId: '请输入仓库编号',
      inputShName: '请输入仓库名称',
      selectShType: '请选择仓库类型',
      inputShDesc: '请输入描述',
      normalWarehouse: '普通仓库',
      mainWarehouse: '总仓库',
      addShopHouse: '添加仓库',
      editShopHouse: '修改仓库',
      deleteConfirm: '删除确认',
      deleteShopHouseConfirm: '确定删除该仓库吗？',
      shNameRequired: '仓库名称不能为空',
      shTypeRequired: '仓库类型不能为空',
      shDescRequired: '描述不能为空',
      shIdRequired: '仓库编号不能为空',
      shNameTooLong: '仓库名称过长',
      shDescTooLong: '描述过长'
    }
  }
}